import { apiFetch } from './base';
import type { GuestBooking } from './types';

export function requestOtp(data: { phone: string }) {
  return apiFetch<{ sent: boolean; masked_contact: string; via: string }>('/api/bookings/request-otp', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export function lookupBookingsByGuest(data: { firebase_id_token: string }) {
  return apiFetch<{ guest_token: string; bookings: GuestBooking[] }>('/api/bookings/lookup-by-guest', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export function getMyBookings(guestToken: string) {
  return apiFetch<GuestBooking[]>('/api/bookings/my-bookings', {
    headers: { Authorization: `Bearer ${guestToken}` },
  });
}

export interface CancelResult {
  success: boolean;
  refund_amount: number;
  refund_percent: number;
  refund_status: 'none' | 'initiated' | 'failed' | 'manual_required';
  razorpay_refund_id: string | null;
  total_amount: number;
}

export function cancelBooking(bookingId: string, guestToken: string) {
  return apiFetch<CancelResult>(`/api/bookings/${bookingId}/cancel`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${guestToken}` },
  });
}

export interface RefundStatusResult {
  refund_id: string;
  status: 'pending' | 'processing' | 'processed' | 'failed' | 'cancelled';
  amount: number;
  created_at: string;
  processed_at: string | null;
  speed: string;
}

export function checkRefundStatus(refundId: string, guestToken: string) {
  return apiFetch<RefundStatusResult>(`/api/bookings/refund-status/${encodeURIComponent(refundId)}`, {
    headers: { Authorization: `Bearer ${guestToken}` },
  });
}
